import { render, staticRenderFns } from "./BudgetSourceList.vue?vue&type=template&id=ed7c2bd8&scoped=true&"
import script from "./BudgetSourceList.vue?vue&type=script&lang=js&"
export * from "./BudgetSourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7c2bd8",
  null
  
)

export default component.exports